import React from 'react'
import PropTypes from 'prop-types'

import ComponentTag from '@cred/react-component-tag'

import * as packageJson from './package.json'
import styles from './tab.module.scss'

const Tab = ({ children, componentTag = {} }) =>
  <div {...componentTag} className={styles.tabChangeAnimation}>
    {children}
  </div>

Tab.propTypes = {
  children: PropTypes.any.isRequired,
}

export default ComponentTag(packageJson)(Tab)
